import { createFileRoute } from '@tanstack/react-router';
import { AppLoadingScreen } from '~/components/app-loading-screen';
import i18n from '~/i18n';
import { authClient } from '~/lib/auth-client';

export const Route = createFileRoute('/sign-in-as')({
  validateSearch: (search): { token?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  loaderDeps: ({ search }) => ({ token: search.token }),
  loader: async ({ deps: { token }, preload }) => {
    if (preload) return;
    if (!token)
      throw new Error(
        i18n.t('Missing sign-in token. Return to ops and try again.', {
          ns: 'auth',
        }),
      );
    const { error } = await authClient.oneTimeToken.verify({ token });
    if (error)
      throw new Error(
        i18n.t(
          'This sign-in link expired or was already used. Return to ops and try again.',
          { ns: 'auth' },
        ),
      );
    // Start the clinic session from the new cookie, in a fresh document.
    window.location.replace('/tasks');
  },
  pendingComponent: () => <AppLoadingScreen />,
  component: () => <AppLoadingScreen />,
  errorComponent: ({ error }) => (
    <main className="flex min-h-screen items-center justify-center bg-muted p-6">
      <p className="text-sm text-muted-foreground">
        {error instanceof Error ? error.message : String(error)}
      </p>
    </main>
  ),
});
